
const initialState = {
    MenuFeature: []
};

const MenuFeatureReducer = (state = initialState, action) => {
  switch (action.type) {
 case "MENU_FEATURE":
      return { ...state, MenuFeature: action.payload };
    default: {
      return state; 
    }
  }};

  export default MenuFeatureReducer;